<script>
  /* global Global */
  import Header from '../common/Header.svelte';
  import Footer from '../common/Footer.svelte';
  import Loading from '../common/Loading.svelte';
  import Error from '../common/Error.svelte';
  import Title from '../common/Title.svelte';
  import CountdownOrLive from '../ui-components/CountdownOrLive.svelte';
  import Button from '../common/Button.svelte';
  import Input from '../common/Input.svelte';
  import Article from '../ui-components/Article.svelte';
  import Common from '../js/common.js';
  import Articles from '../js/articles.js';

  export let params;

  let lang;

  let user = JSON.parse(window.localStorage.getItem('user'));

  let allArticles = [];
  let articles = [];

  let loading = true;
  let error = false;

  let findByValue = params?.find || '';

  (async () => {
    // eslint-disable-next-line no-undef
    const response = await fetch(`${Common.BACKEND_URL}/articles/get`);

    if (response.ok) {
      const data = await response.json();

      allArticles = data.articles;
      user = data.user;

      allArticles = Common.sortArrayOfObjectsByKey(allArticles, ['date'], true);

      if (user) window.localStorage.setItem('user', JSON.stringify(data.user));
      else window.localStorage.removeItem('user');
    } else {
      error = true;
    }

    loading = false;
  })();

  const i18n = {
    pageTitle: {
      cs: `Články | ${Global.project.name.cs}`,
      en: `Articles | ${Global.project.name.en}`,
    },
    title: {
      cs: 'Články',
      en: 'Articles',
    },
    find: {
      cs: 'Vyhledat',
      en: 'Find',
    },
    addArticle: {
      cs: 'Přidat článek',
      en: 'Add article',
    },
  };

  $: if (findByValue) {
    articles = Articles.findArticles(allArticles, findByValue, lang);
  } else {
    articles = allArticles;
  }

  const dateFrom = Global.date.from;
  const dateTo = Global.date.to;
</script>

<svelte:head>
  <title> {i18n.pageTitle[lang]} </title>
</svelte:head>

<Header page='articles' bind:lang bind:user/>

<Title subtitle='{dateFrom} – {dateTo}' home={true} bind:lang bind:user/>

<CountdownOrLive bind:lang/>

<div class='articles' class:articles-loading-or-error={loading || error}>
  <Loading bind:display={loading} home={true}/>
  <Error bind:display={error} home={true} bind:lang/>

  {#if !loading && !error}
    <div class='articles-content'>
      {#if user}
        <div class='articles-content-admin'>
          <Button value={i18n.addArticle[lang]} icon='add' admin={true}
            onClick={() => { window.location.href = './#/admin/articles/add'; }}/>
        </div>
      {/if}

      <div class='articles-content-find-by'>
        <Input bind:value={findByValue} label={i18n.find[lang]} icon='search'/>
      </div>

      {#if articles.length > 0}
        <div class='articles-content-box'>
          {#each articles as article}
            {#if article.perex[lang]}
              <Article value={article} bind:lang admin={!!user}/>
            {/if}
          {/each}
        </div>
      {/if}
    </div>
  {/if}
</div>

<Footer bind:lang/>

<style>
  .articles {
    max-width: 1450px;

    padding: 40px 60px;

    margin: auto;
  }

  .articles-loading-or-error {
    padding: 30px 60px;
  }

  .articles-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .articles-content-box {
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  @media only screen and (max-width: 900px) {
    .articles {
      padding: 40px;
    }

    .articles-loading-or-error {
      padding: 30px 40px;
    }
  }

  @media only screen and (max-width: 350px) {
    .articles {
      padding: 40px 20px;
    }

    .articles-loading-or-error {
      padding: 30px 20px;
    }
  }
</style>
